import api from "../http";

export default class AuthAPI {
    static async login(email, password) {
        return api.post('/user/login', { email, password });
    }

    static async registration(email, name, surname, password) {
        return api.post('/user/registration', { email, name, surname, password });
    }

    static async logout() {
        return api.post('/user/logout');
    }

    static async account() {
        return api.get('/user/user');
    }

    static async editWorkTime(workTime) {
        return api.post('/user/edit/workTime', { workTime });
    }

    static async editFinalDiscount(finalDiscount) {
        return api.post('/user/edit/finalDiscount', { finalDiscount });
    }

    static async editDiscountPrice(discountPrice) {
        return api.post('/user/edit/discountPrice', { discountPrice });
    }

    static async editPaydayCountWorkers(countWorkers) {
        return api.post('/user/edit/paydayWorkers', { countWorkers });
    }
}
